import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kiloByte'
})
export class KiloBytePipe implements PipeTransform {

  transform(value: number) {

    return (Math.round(100 * value / (1024 )) / 100).toString();
  }

}
